module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/main-visual-7e79de7f4903efe54e43af7680136d98.jpg";